'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(require('react'));

var _svg;

/**
 * Component dependencies
 */

/**
 * Component
 */


var Icon = function Icon(_ref) {
  var color = _ref.color,
      i18n = _ref.i18n;
  return _svg || (_svg = /*#__PURE__*/react.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#00A64F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.8049 9.23958H10.9549V6.74608H14.6599V5.21608H10.9569V2.81958H9.04545V5.21608V5.22558H8.23944C6.49695 5.22558 5.04395 6.10608 5.04395 8.02558C5.04395 9.70458 6.31795 10.7611 8.19395 10.7611H9.04395V13.2541H5.33995V14.7841H9.04295V17.1811H10.9544V14.7746H11.7604C13.5029 14.7746 14.9559 13.8941 14.9559 11.9746C14.9559 10.2961 13.6819 9.23958 11.8049 9.23958ZM9.04295 10.7601V9.24008H8.43995C7.63045 9.24008 6.97144 8.89908 6.97144 7.99008C6.97144 7.09008 7.59645 6.74808 8.47995 6.74808H9.04545V9.24158H10.9544V10.7601H9.04295ZM11.5199 13.2541H10.9544V10.7606H11.5599C12.3694 10.7606 13.0284 11.1016 13.0284 12.0106C13.0284 12.9141 12.4034 13.2541 11.5199 13.2541Z",
    fill: "white"
  })));
};

Icon.defaultProps = {
  color: 'rgba(0, 0, 0, 0.9)'
};
/**
 * Export component
 */

var USDP20 = Icon;

module.exports = USDP20;
